import { add, getUnixTime } from "date-fns";
import { countries } from "@/settings/home-page-settings-countries";

export function addressSetter(addressData) {
    if (addressData) {
        return {
            streetNumber: addressData.metadata?.context?.address?.address_number || "",
            streetName: addressData.metadata?.context?.address?.street_name || "",
            name: addressData.metadata?.context?.address?.name || "",
            locality: addressData.components?.city || "",
            adminAreaLevel1: addressData.metadata?.context?.region?.region_code || "",
            adminAreaLevel2: addressData.components?.region || "",
            country: addressData.components?.country || "",
            postal: addressData.components?.zip || "",
            point: {
                lat: addressData.lat || "",
                lng: addressData.lng || "",
            },
            fullAddress: addressData.formatted_address || "",
            cacheExpiryDate: getUnixTime(add(new Date(), { days: 30 })),
        };
    } else {
        return null;
    }
}

export function locationSetter(addressData) {
    if (addressData) {
        let fullAddress = null;
        if (
            addressData.components?.city &&
            addressData.metadata?.context?.region?.region_code &&
            addressData.components?.country
        ) {
            fullAddress =
                addressData.components.city +
                ", " +
                addressData.metadata.context.region.region_code +
                ", " +
                addressData.components.country;
        } else if (addressData.formatted_address) {
            fullAddress = addressData.formatted_address;
        }
        return {
            streetNumber: addressData.metadata?.context?.address?.address_number || "",
            streetName: addressData.metadata?.context?.address?.street_name || "",
            name: addressData.metadata?.context?.address?.name || "",
            locality: addressData.components?.city || "",
            adminAreaLevel1: addressData.metadata?.context?.region?.region_code || "",
            adminAreaLevel2: addressData.components?.region || "",
            country: addressData.components?.country || "",
            postal: addressData.components?.zip || "",
            point: {
                lat: addressData.lat || "",
                lng: addressData.lng || "",
            },
            fullAddress: fullAddress,
            cacheExpiryDate: getUnixTime(add(new Date(), { days: 30 })),
        };
    } else {
        return null;
    }
}

export function locationGetter(location) {
    return {
        components: {
            city: location.locality || "",
            state: location.adminAreaLevel1 || "",
            region: location.adminAreaLevel2 || "",
            country: location.country || "",
            zip: location.postal || "",
        },
        lat: location.point?.lat || "",
        lng: location.point?.lng || "",
        formatted_address: location.fullAddress || "",
    };
}

export function addressDetailToGeoAddress(addressData) {
    const country = countries.find((c) => c.value === addressData.country);

    return {
        fullAddress: [addressData.line1, addressData.city, addressData.state, addressData.postal_code, country.text]
            .filter((item) => {
                return !!item;
            })
            .join(", "),
        adminAreaLevel1: addressData.state,
        adminAreaLevel2: null,
        locality: addressData.city,
        country: country.text,
        streetNumber: null,
        name: addressData.line1,
        postal: addressData.postal_code,
        point: {
            lat: null,
            lng: null,
        },
        cacheExpiryDate: getUnixTime(add(new Date(), { days: 30 })),
    };
}

export function geoAddressToAddressDetail(address) {
    const country = countries.find((c) => c.text === address.country);
    return {
        line1: address.name,
        line2: null,
        city: address.locality,
        state: address.adminAreaLevel1,
        country: country.value,
        postal_code: address.postal,
    };
}

export function getFullAddressFromAddressDetail(address) {
    if (!address || Object.keys(address).length === 0) {
        return "";
    }
    const country = countries.find((c) => c.value === address.countryCode);
    return [address.line2, address.line1, address.city, address.state, address.postalCode, country.text]
        .filter((item) => {
            return !!item;
        })
        .join(", ");
}

export function billingAddressToCheckout(address) {
    const country = countries.find((c) => c.value === address.countryCode);
    return {
        line1: address.line1,
        line2: address.line2,
        city: address.city,
        state: address.state,
        country: country.text,
        postal_code: address.postalCode,
    };
}

export function fullAddressToCheckout(address) {
    return {
        line1: address.name,
        line2: null,
        city: address.locality,
        state: address.adminAreaLevel1,
        country: address.country,
        postal_code: address.postal,
    };
}

export function shippingAddressLoader(addressData) {
    const country = countries.find((c) => c.value === addressData.countryCode);
    return {
        fullAddress: [addressData.line1, addressData.city, addressData.state, addressData.postalCode, country.text]
            .filter((item) => {
                return !!item;
            })
            .join(", "),
        adminAreaLevel1: addressData.state,
        adminAreaLevel2: null,
        locality: addressData.city,
        country: country.text,
        streetNumber: null,
        name: addressData.line1,
        postal: addressData.postalCode,
        point: {
            lat: null,
            lng: null,
        },
        cacheExpiryDate: getUnixTime(add(new Date(), { days: 30 })),
    };
}

export function parseAddressToAddressDetail(addressString) {
    const addressArray = addressString.split(",").map((item) => item.trim());
    let addressObject = {};
    if (addressArray.length > 5) {
        addressObject = {
            line2: addressArray[0],
            line1: addressArray[1],
            city: addressArray[2],
            state: addressArray[3],
            postalCode: addressArray[4],
            country: addressArray[5],
        };
    } else {
        addressObject = {
            line2: null,
            line1: addressArray[0],
            city: addressArray[1],
            state: addressArray[2],
            postalCode: addressArray[3],
            country: addressArray[4],
        };
    }

    return addressObject;
}
